export default __webpack_public_path__ + "static/media/home-stadium-bg.fa121102.png";